import type { IDockviewPanelProps } from 'dockview';
import {
  DEFAULT_PRICE_BLOTTER_COLUMNS,
  DEFAULT_PRICE_BLOTTER_FILTER,
  PriceBlotter,
} from '../../../../containers/Blotters/PriceBlotter';
import type { PriceGridPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';

export function PriceGridPanel({ api }: IDockviewPanelProps<PriceGridPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="price-grid-panel">
      <PriceBlotter
        blotterID={`price-grid/${api.id}`}
        defaultColumns={DEFAULT_PRICE_BLOTTER_COLUMNS}
        defaultFilter={DEFAULT_PRICE_BLOTTER_FILTER}
      />
    </Panel>
  );
}
